import { Component, Prop, Watch } from "vue-property-decorator";
import axios, { AxiosPromise } from "axios";
import { mapActions, mapGetters, mapMutations } from "vuex";
import baseUserContextComponent from "../baseUserContextComponent";
import eventHub from "../../eventHub";
import { ShoppingCartModel, CartProductModel } from "@/models/shoppingCartModel";
import { sisasListiniModel } from "@/models/sisasPimListiniModel";
import { umDefinition } from "@/models/umDefinition";
import baseUserContextProductComponent from "../baseUserContextProductComponent";
import { DMSDocument } from "@/models/dmsDocument";
@Component({
  computed: {
    ...mapGetters(["getCurrentOffer"])
},
methods: {
    ...mapMutations(["setCurrentOffer"])
}
})
export default class offerProductListItemGroup extends baseUserContextProductComponent {
    listafiles: Array<DMSDocument> = [];
    files = null;
    @Prop({ default: () => false })
    readonly: boolean;
    @Prop({ default: () => "" })
    size: string;
    @Prop({ default: () => [] })
    products: CartProductModel[];
    @Prop({ default: () => false })
    showNoteStato: boolean;
    @Prop({ default: () => true })
    showImage: boolean;
    @Prop({ default: () => [] })
    listini: sisasListiniModel[];

    @Watch("products", { deep: true })
    onProductChange(val: CartProductModel, oldVal: CartProductModel) {
        this.note = this.product.code2;
        this.savedNote = this.note;
        // this.fetchListFile();
    }
    // @Watch("products", { deep: true })
    // onProductChange(val: CartProductModel[], oldVal: CartProductModel[]) {

    //   this.note = this.product.code2;
    //   this.savedNote = this.note;
    //   this.fetchListFile();
    // }
    // @Watch("productId", { deep: true })
    // onProductIdChange(val: number, oldVal: number) {
    //     if (val != oldVal) this.fetchListFile();
    // }

    getCurrentOffer!: ShoppingCartModel;
    setCurrentOffer!: (cart: ShoppingCartModel | null) => void;

    get product(): CartProductModel {
        return this.products == null || this.products.length == 0 ? new CartProductModel() : this.products[0];
    }
    get productId(): number {
        return this.product == null || this.product.product == null ? null : this.product.product.id;
    }
    get totalQuantity(): number {
        if (this.products == null || this.products.length == 0) return 0;
        return this.products.reduce((a, b) => a + b.quantity, 0);
    }
    get noteSate(): boolean | null {
        var self = this;
        if (self.showNoteStato == true) {
            var n = self.savedNote;
            if (n == null || n.length === 0 || n.trim() == "") return false;
            else return true;
        }
        return null;
    }
    isInEditQuantity: boolean = false;
    isSendingQuantity: boolean = false;
    isInEditNote: boolean = false;
    isSendingNote: boolean = false;
    isSendingDelete: boolean = false;
    isSendingFile: boolean = false;
    get isSendingData(): boolean {
        return this.isSendingDelete || this.isSendingNote || this.isSendingQuantity || this.isSendingFile;
    }
    note: string = null;
    savedNote: string | null = null;

    quantity: number = null;

    getProductByUM(um: string): CartProductModel {
        if (this.products == null || this.products.length == 0) return new CartProductModel();
        var p = this.products.find((x) => x.code1 == um);
        return p == null ? new CartProductModel() : p;
    }

    get cart(): ShoppingCartModel {
        return this.getCurrentOffer;
    }
    getDetailUrl(): string {
        return "/product/" + this.product.productId;
    }

    created() {
        this.note = this.product.code2;
        this.savedNote = this.note;
        //if (this.productId != null) this.fetchListFile();
    }
    mounted() {}

    setEditNote() {
        this.isInEditNote = true;
        this.$emit("edit", this.isInEditQuantity || this.isInEditNote);
    }
    canelEditNote() {
        this.isInEditNote = false;
        this.note = this.product.code2;
        this.$emit("edit", this.isInEditQuantity || this.isInEditNote);
    }
    confirmEditNote() {
        var instance = this;
        instance.isSendingNote = true;
        this.$emit("sendingData", this.isSendingData);
        axios
            .post<ShoppingCartModel>(`cart/offer/setnoteproduct/${this.getCurrentCustomerId}/${this.cart.id}`, {
                customerId: instance.getCurrentCustomerId,
                productId: instance.productId,
                note: instance.note
            })
            .then((res) => {
                instance.setCurrentOffer(res.data);
                instance.$notify({
                    title: "",
                    text: "Le note sono state modificate",
                    type: "success",
                    group: "msg"
                });

                instance.isSendingNote = false;
                instance.isInEditNote = false;
                instance.$emit("edit", this.isInEditQuantity || this.isInEditNote);
                instance.$emit("sendingData", this.isSendingData);
            })
            .catch((error) => {
                console.error(error);
                instance.isSendingNote = false;
                instance.canelEditNote();
                instance.$emit("sendingData", this.isSendingData);
            });
    }

    get showUploadFiles(): boolean {
        var self = this;
        return self.isFileRichiesto((self.product || new CartProductModel()).product);
    }
    get showSetNote(): boolean {
        var self = this;
        return self.isNoteRichieste((self.product || new CartProductModel()).product);
    }
    get showLabelNote(): string {
        var self = this;
        return self.getLabelNoteRichieste((self.product || new CartProductModel()).product);
    }
}
